export enum TaskStatus {
  INITIATED = 'initiated',
  ACTIVE = 'active',
  COMPLETE = 'complete',
  UA_CLOSED = 'UA_closed',
  ESCALATED = 'escalated',
  NOTIFY = 'notify',
  CLOSED = 'closed',
}
